function Logo() {
  return (
    <span className="brand">
      <span className="brand-mark">AC</span>
      Australia College
    </span>
  );
}

export default Logo;
